// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__YWUxW","inner":"Form_inner__BlMgC","range":"Form_range__AsSww","name":"Form_name__i4Sm3","actions":"Form_actions__nUJSp"};